import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LgvAPIService, LgvClientService, LgvUserService } from '../../core/core.module';
import { first } from 'rxjs/operators';
import { LgvDataHelper } from '../../core/utility/lgv-data-helper';
import { LgvModel } from '../../data-models/longevity.model';

@Component({
    selector: 'popup-mgr',
    styleUrls: ['./popup-mgr.component.scss'],
    templateUrl: 'popup-mgr.component.html',
})

export class PopupMgr {

    //Custom Popups



    get HaveDictionaryItem(): boolean { return this.data && this.data.mode && this.Dictionary[this.data.mode] !== null; }
    get DictionaryObject(): boolean { return this.HaveDictionaryItem ? this.Dictionary[this.data.mode] : null; }

    Dictionary = {
        'XXX': {
            "Header": "Principal",
            "Body": "The principal is the amount of money you owe on your home loan, and the amount shown is how much you have paid on said principal. The more money you pay on the principal will reduce the amount you pay in interest."
        },
        'InactiveClients': {
            "Header": "Inactive Clients",
            "Body": "<br>Inactive clients are unable to access their HomeDashboard platform and are excluded from email campaigns. You can re-activate a client by clicking \"Make Active\" in the dropdown menu.<br/>"
        }

    }

    constructor(
        public dialogRef: MatDialogRef<PopupMgr>,
        private router: Router,
        public LgvUserSvc: LgvUserService,
        public LgvDataHlpr: LgvDataHelper,
        private LgvClientSvc: LgvClientService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.LgvClientSvc.PostPageClick(`Learn about - ${data.mode}`).pipe(first()).subscribe();


    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}
